import { c as _c } from "react/compiler-runtime";
import { getOrgArtifactsQueryKey, patchOrgArtifactsByArtifactIdMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { CursorPaginatedOrgArtifact } from '@onefootprint/request-types/dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// On success, writes the new name into the cached list so the dropdown trigger updates
// without a refetch. Don't invalidate — rename is metadata-only, and skipping the refetch
// avoids a visible flicker where selection falls back to "Generated Summary".
const useRenameArtifact = () => {
  const $ = _c(6);
  const queryClient = useQueryClient();
  const showErrorToast = useRequestErrorToast();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = patchOrgArtifactsByArtifactIdMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = (_data, variables) => {
      const artifactId = variables.path?.artifactId;
      const newName = variables.body?.name;
      if (!artifactId || typeof newName !== "string") {
        return;
      }
      queryClient.setQueriesData({
        queryKey: getOrgArtifactsQueryKey()
      }, old => old ? {
        ...old,
        data: old.data.map(a => a.id === artifactId ? {
          ...a,
          name: newName
        } : a)
      } : old);
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== showErrorToast || $[4] !== t1) {
    t2 = {
      ...t0,
      onSuccess: t1,
      onError: showErrorToast
    };
    $[3] = showErrorToast;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useMutation(t2);
};
export default useRenameArtifact;